module.exports = __webpack_public_path__ + "static/media/8.d11b9114.jpg";